import style from "./Bucket.module.scss";
// import LinkIcon from "../../../assets/images/bucket/linkIcon.png";
// import DeleteIcon from "../../../assets/images/bucket/deleteIcon.png";
// import QuantityIcon from "../../../assets/images/bucket/quantityIcon.png";
// import { Link } from "react-router-dom";
import BucketProduct from "../../../components/pages/admin-panels/bucket/BucketProduct";

const Bucket = () => {
  const handleDelete = () => {
  };
  return (
    <>
      <div className={style.PayAll}>
        <p onClick={(e) => e.currentTarget.classList.toggle("clicked")}>
          <span></span> Toplu ödəniş et
        </p>
      </div>
      <div id={style.bucketProductsList}>
        <BucketProduct
          productLink="https://trendyol.com/urun-linki"
          productLinkTitle="Məhsulun linki"
          productCountTitle="Məhsulun sayı"
          productCount={1}
          resultPrice="1800 TL"
          onDelete={handleDelete}
        />
        <BucketProduct
          productLink="https://trendyol.com/urun-linki"
          productLinkTitle="Məhsulun linki"
          productCountTitle="Məhsulun sayı"
          productCount={1}
          resultPrice="1800 TL"
          onDelete={handleDelete}
        />
        <BucketProduct
          productLink="https://trendyol.com/urun-linki"
          productLinkTitle="Məhsulun linki"
          productCountTitle="Məhsulun sayı"
          productCount={1}
          resultPrice="1800 TL"
          onDelete={handleDelete}
        />
      </div>
      <div id={style.acceptBucketPart}>
        <p className={style.resultCost}>
          Yekun məbləğ <span>600.00 TL</span>
        </p>
        <p className={style.payNow}>Ödəniş et</p>
      </div>
    </>
  );
};

export default Bucket;
